import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 8px;
`;

const ErrorIcon = styled.span`
  color: red;
  font-size: 18px;
  cursor: pointer;
`;

const Tooltip = styled.div`
  visibility: hidden;
  width: 200px;
  background-color: #f44336; 
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 8px;
  position: absolute;
  z-index: 1;
  bottom: 125%; 
  left: 50%;
  margin-left: -100px;
  opacity: 0;
  transition: opacity 0.3s;

  &::after {
    content: '';
    position: absolute;
    top: 100%; 
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #f44336 transparent transparent transparent;
  }
`;

const ErrorIconWrapper = styled.div`
  display: inline-block;
  position: relative;

  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`;

const FieldError = ({ error }) => {
  if (!error) return null;

  return (
    <ErrorContainer>
      <ErrorIconWrapper>
        <ErrorIcon>⚠️</ErrorIcon>
        <Tooltip>{error}</Tooltip>
      </ErrorIconWrapper>
    </ErrorContainer>
  );
};

export default FieldError;
